<template>
  <button @click.stop="$emit('click')"
 >{{text?text:'取消'}}</button>
</template>

<script>
export default {
  props: ['text']
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
button {
  height: 35px;
  color: #FFFFFF;
  width: 100px;
  letter-spacing: 0.1em;
  font-weight: 400;
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #B9B9B9;
  border-radius: 20px;
}
}
</style>

<style lang="scss" scoped>
@media screen and (orientation: portrait) {
button {
}
}
</style>
